import { render, staticRenderFns } from "./ToolbarSettings.vue?vue&type=template&id=4d900f2a"
import script from "./ToolbarSettings.vue?vue&type=script&lang=js"
export * from "./ToolbarSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d900f2a')) {
      api.createRecord('4d900f2a', component.options)
    } else {
      api.reload('4d900f2a', component.options)
    }
    module.hot.accept("./ToolbarSettings.vue?vue&type=template&id=4d900f2a", function () {
      api.rerender('4d900f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar/ToolbarSettings.vue"
export default component.exports